import { useState, useEffect } from "react"
import { navigate } from "vike/client/router"
import Button from "aldoo-ra/Button"
import MenuGroup from "aldoo-ra/MenuGroup"
import PlatformAuth from "aldoo-ra/PlatformAuth"
import AccountButton from "./AccountButton"
import LogoFull from "../Logo/LogoFull"

// Auth-gated item — the Download entry only makes sense once signed in
// (installer lives in the account Downloads section). CMS defines it via
// options.action="downloads" rather than a link, since it has no CMS page.
const DOWNLOADS_ACTION = "downloads"
const DOWNLOADS_URL = "/account/downloads"

export default function NavbarDesktop() {
  const [isScrolled, setIsScrolled] = useState(false)
  const [mounted, setMounted] = useState(false)
  const [auth] = PlatformAuth.useAuth()

  useEffect(() => setMounted(true), [])

  useEffect(() => {
    const handleScroll = () => {
      // aldoo-ra/Modal locks body scroll via position:fixed while open,
      // which makes window.scrollY read 0 — skip so the scrolled
      // background doesn't flicker off behind an open modal.
      if (document.body.style.position === "fixed") return
      setIsScrolled(window.scrollY > 10)
    }

    handleScroll()
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <header
      className={`fixed top-0 left-0 right-0 w-full z-50 transition-all duration-300 ${
        isScrolled ? 'bg-paper/60 backdrop-blur-lg shadow-md border-b border-border' : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="h-16 flex items-center justify-between">
          {/* Logo */}
          <div
            className="w-[150px] flex-shrink-0 cursor-pointer"
            onClick={() => navigate("/")}
          >
            <LogoFull textColor = "text" />
          </div>

          {/* Navigation Menu */}
          <nav className="hidden md:flex items-center gap-8">
            <MenuGroup
              name="HeaderMenuCentral"
              renderAs="hlist"
              itemsAsLinks={false}
              styleOverrides={{
                menu: "flex flex-row items-center gap-8 py-0 my-0",
                menu_item: "list-none px-0 py-0 my-0",
              }}
              menuItemRender={(item) => {
                const isDownloads = item.options?.action === DOWNLOADS_ACTION
                if (isDownloads && !(mounted && auth?.auth_token)) return null

                const url = isDownloads ? DOWNLOADS_URL : item.link?.[0]?.url

                return (
                  <a
                    href={url}
                    className="xl:text-lg text-text hover:text-primary transition-colors font-medium"
                  >
                    {item.label}
                  </a>
                )
              }}
            />
          </nav>

          {/* CTA + account */}
          <div className="flex items-center gap-4">
            <MenuGroup
              name="BuyNow"
              renderAs="hlist"
              itemsAsLinks={false}
              styleOverrides={{
                menu: "flex flex-row items-center py-0 my-0",
                menu_item: "list-none px-0 py-0 my-0",
              }}
              menuItemRender={(item) => (
                <Button
                  variant="primary"
                  onClick={() => navigate(item.link?.[0]?.url)}
                >
                  {item.label}
                </Button>
              )}
            />
            <AccountButton />
          </div>
        </div>
      </div>
    </header>
  )
}